import { Component, OnInit, signal, inject } from '@angular/core';
import { UserService } from '../../shared/core/state/users/users.service';
import { linkedAccountsResponse } from '../../shared/core/state/users/models';
import { environment } from '../../../../src/environments/environment';
import { StorageService } from '../../shared/util/storage.service';
import { CONST } from '../../shared/util/const';
import { finalize } from 'rxjs';

import { ToastService } from '@black/ui';

@Component({
  selector: 'black-accounts',
  standalone: false,

  templateUrl: './accounts.component.html',
  styleUrl: './accounts.component.css',
})
export class AccountsComponent implements OnInit {
  private userService = inject(UserService);
  private storageService = inject(StorageService);
  private toastService = inject(ToastService);

  linkedAccounts: linkedAccountsResponse[] = [];
  currentUser = signal<any>(null);

  isPageLoading = signal(false);

  ngOnInit(): void {
    this.isPageLoading.set(true);
    this.userService
      .getUserInfo()
      .pipe(finalize(() => this.isPageLoading.set(false)))
      .subscribe((data) => {
        this.currentUser.set(data);
        this.linkedAccounts = data.linkedAccounts ?? [];
      });
  }

  linkNewAccount() {
    const user = this.currentUser();
    if (user?.profile?.personal?.dateOfBirth) {
      const dob = new Date(user.profile.personal.dateOfBirth);
      const age = new Date(Date.now() - dob.getTime()).getUTCFullYear() - 1970;
      if (age < 16) {
        this.toastService.showToast(
          'Users under 16 years of age are not permitted to connect Zoom accounts.',
          'error'
        );
        return;
      }
    }

    const returnUrl = window.location.pathname;

    this.storageService.set(
      CONST.STORAGE_KEYS.ZOOM_RETURN_URL,
      returnUrl
    );

    const redirectUrl = `${window.location.origin}/auth/zoom-callback`;

    const authUrl = `https://zoom.us/oauth/authorize?response_type=code&client_id=${environment.zoomAppKey}&redirect_uri=${redirectUrl}`;
    window.location.href = authUrl;
  }

  unlinkAccount(data: { provider: string; userId: string }) {
    this.userService.unlinkAccount(data.provider, data.userId).subscribe(() => {
      this.linkedAccounts = this.linkedAccounts.filter(
        (account) => account.userId !== data.userId
      );
    });
  }
}
